import React from 'react';
import Image from '../Image';
import ReactDOM from 'react-dom';


interface BaseModal {
  children: React.ReactNode;
  closeModalIcon: string;
  styles: {
    modalContainer: string;
    closeModalIcon: string;
  };
  onClose: () => void;
  manualAffix?: string;
}

const BaseModal: React.FC<BaseModal> = ({ children, closeModalIcon, styles, onClose, manualAffix = '.svg' }) => {
  return ReactDOM.createPortal(
    <div className={styles.modalContainer}>
      <Image className={styles.closeModalIcon} src={closeModalIcon} manualAffix={manualAffix} onClick={onClose} />
      {children}
    </div>,
    document.body,
  );
};
export default BaseModal;
